import React, { useState, useEffect } from "react";
import "./activitylog.css";
import { baseRequest } from "../../../axiosconfig";
import Loading from "../../loading";
import DropDown from "../../elements/dropDown";

const ACTION_LABELS = {
  create: "Kreiranje",
  update: "Izmena",
  delete: "Brisanje",
  download: "Preuzimanje",
  import: "Uvoz",
  login: "Prijava",
  login_failed: "Neuspešna prijava",
  logout: "Odjava",
};

const ENTITY_LABELS = {
  auth: "Prijava/odjava",
  user: "Korisnički nalog",
  employee: "Zaposleni",
  organization_unit: "Organizaciona jedinica",
  designation: "Radno mesto",
  business_process: "Poslovni proces",
  business_process_list: "Lista poslovnih procesa",
  process_map: "Mapa procesa",
  procedure: "Procedura",
  activity_document: "Propratni dokument",
  risk_form: "Formular rizika",
  self_assessment: "Upitnik za samoprocenu",
  organization_structure: "Organizaciona struktura",
  user_accounts: "Korisnički nalozi",
  business_processes: "Poslovni procesi (uvoz)",
  export: "Izvoz podataka",
};

const actionFilterList = Object.entries(ACTION_LABELS).map(([id, name], i) => ({
  id,
  name,
}));

const entityFilterList = Object.entries(ENTITY_LABELS).map(([id, name]) => ({
  id,
  name,
}));

function ActivityLog() {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [actionFilter, setActionFilter] = useState({ id: "all", name: "ALL" });
  const [entityFilter, setEntityFilter] = useState({ id: "all", name: "ALL" });

  const [error, setError] = useState("");

  const loadLogs = (targetPage, action, entity) => {
    setLoading(true);
    setError("");
    const params = { page: targetPage, limit: 50 };
    if (action && action.id !== "all") params.action = action.id;
    if (entity && entity.id !== "all") params.entity = entity.id;

    baseRequest
      .get("/audit_logs", { params })
      .then((res) => {
        setLogs(res.data.audit_logs || []);
        setPage(res.data.page);
        setPages(res.data.pages);
        setTotal(res.data.total);
        setLoading(false);
      })
      .catch((err) => {
        setLogs([]);
        setPage(1);
        setPages(1);
        setTotal(0);
        setError(
          err.response?.status === 403
            ? "Nemate pravo pristupa evidenciji aktivnosti (samo administrator)."
            : "Učitavanje evidencije nije uspelo."
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    loadLogs(1, actionFilter, entityFilter);
  }, [actionFilter, entityFilter]);

  const formatDateTime = (d) =>
    `${new Date(d).toLocaleDateString("sr-RS")} ${new Date(d).toLocaleTimeString("sr-RS", { hour: "2-digit", minute: "2-digit" })}`;

  return (
    <div className="activity-log">
      <div className="processes-header activity-log-header">
        <DropDown
          dropDownStyle={{ borderRight: "1px solid var(--mainColor)", width: "30%" }}
          height={"49px"}
          list={actionFilterList}
          onChange={({ value }) => setActionFilter(value)}
          selectedValue={actionFilter?.name}
          isFilter={true}
        />
        <DropDown
          dropDownStyle={{ borderRight: "1px solid var(--mainColor)", width: "40%" }}
          height={"49px"}
          list={entityFilterList}
          onChange={({ value }) => setEntityFilter(value)}
          selectedValue={entityFilter?.name}
          isFilter={true}
        />
        <span className="activity-log-total">Ukupno zapisa: {total}</span>
      </div>

      <div className="table-scroll">
      <table className="activity-log-table">
        <thead>
          <tr>
            <th style={{ width: "140px" }}>DATUM I VREME</th>
            <th style={{ width: "180px" }}>KORISNIK</th>
            <th style={{ width: "110px" }}>AKTIVNOST</th>
            <th style={{ width: "180px" }}>ENTITET</th>
            <th>OPIS</th>
          </tr>
        </thead>
        <tbody>
          {logs.length === 0 && !loading && (
            <tr>
              <td colSpan={5} className="activity-log-empty">
                {error || "Nema zabeleženih aktivnosti."}
              </td>
            </tr>
          )}
          {logs.map((log) => (
            <tr key={log.id}>
              <td>{formatDateTime(log.created_at)}</td>
              <td>{log.user_name}</td>
              <td>{ACTION_LABELS[log.action] || log.action}</td>
              <td>{ENTITY_LABELS[log.entity] || log.entity}</td>
              <td>{log.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      {pages > 1 && (
        <div className="activity-log-pagination">
          <button
            className="add-btn-large"
            disabled={page <= 1}
            onClick={() => loadLogs(page - 1, actionFilter, entityFilter)}
          >
            Prethodna
          </button>
          <span>
            Strana {page} od {pages}
          </span>
          <button
            className="add-btn-large"
            disabled={page >= pages}
            onClick={() => loadLogs(page + 1, actionFilter, entityFilter)}
          >
            Sledeća
          </button>
        </div>
      )}

      <Loading isLoading={loading} />
    </div>
  );
}

export default ActivityLog;
